
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BScComputerScienceCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Sc. Computer Science",
    shortName: "B.Sc. CS",
    duration: "3 years",
    description: "Bachelor's degree program focused on computer science fundamentals, programming, and software development",
    overview: "Bachelor of Science in Computer Science (B.Sc. CS) is a 3-year undergraduate program that provides comprehensive study of computer science principles, programming languages, data structures, algorithms, and software engineering. This course covers programming, database systems, computer networks, web development, and emerging technologies, preparing students for careers in IT industry and research.",
    eligibility: [
      "10+2 with Mathematics as main subject",
      "Minimum 60% marks in 12th standard",
      "Physics and Chemistry/Computer Science preferred",
      "Interest in programming and technology"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Programming Fundamentals (C/C++)",
          "Mathematics for Computer Science",
          "Digital Logic",
          "Computer Fundamentals",
          "Physics",
          "English Communication"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures and Algorithms",
          "Object-Oriented Programming (Java)",
          "Database Management Systems",
          "Computer Organization",
          "Web Technologies",
          "Statistics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Software Engineering",
          "Computer Networks",
          "Operating Systems",
          "Artificial Intelligence",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Software Developer",
        "Web Developer",
        "System Analyst",
        "Database Administrator",
        "Network Administrator",
        "Quality Assurance Engineer",
        "Technical Support Engineer",
        "Data Analyst",
        "Cybersecurity Analyst",
        "Mobile App Developer"
      ],
      industries: [
        "Information Technology",
        "Software Development",
        "E-commerce",
        "Banking and Finance",
        "Healthcare IT",
        "Gaming Industry",
        "Telecommunications",
        "Government IT",
        "Consulting Firms",
        "Startups"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹10-30 LPA (Experienced)",
      topRecruiters: [
        "TCS, Infosys, Wipro",
        "Google, Microsoft, Amazon",
        "Flipkart, Paytm, Swiggy",
        "Accenture, IBM, Cognizant",
        "Banking IT Divisions",
        "Government IT Organizations"
      ]
    },
    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some universities conduct entrance tests",
      "Cut-off based on Mathematics scores",
      "Online application process",
      "Counselling and seat allocation"
    ],
    topColleges: [
      {
        name: "St. Xavier's College",
        location: "Mumbai",
        fees: "₹45,000",
        ranking: "Autonomous College"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹1,80,000",
        ranking: "Deemed University"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹25,000",
        ranking: "Government College"
      },
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹60,000",
        ranking: "Autonomous College"
      }
    ],
    skills: [
      "Programming Languages",
      "Software Development",
      "Database Management",
      "Web Development",
      "Problem Solving",
      "Algorithm Design",
      "System Analysis",
      "Project Management",
      "Technical Documentation",
      "Testing and Debugging"
    ],
    futureScope: "Excellent growth prospects with digital transformation, AI/ML revolution, cloud computing, cybersecurity, and increasing demand for software professionals across all industries.",
    faqs: [
      {
        question: "What's the difference between B.Sc. CS and B.Tech. CSE?",
        answer: "B.Sc. CS focuses more on theoretical computer science and programming, while B.Tech. CSE includes engineering principles and system design. Both lead to similar career opportunities."
      },
      {
        question: "Can I get IT jobs with B.Sc. Computer Science?",
        answer: "Yes, B.Sc. CS graduates are recruited by all major IT companies for software development, testing, and technical support roles."
      },
      {
        question: "Is mathematics important for this course?",
        answer: "Yes, mathematics is crucial for algorithms, data structures, discrete mathematics, and advanced computer science concepts."
      },
      {
        question: "Can I pursue higher studies after B.Sc. CS?",
        answer: "Yes, you can pursue M.Sc. CS, MCA, M.Tech in Computer Science, or even MBA in IT management."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BScComputerScienceCoursePage;
